export class DefaultVerbalSettings {
  constructor() {
    this.audio_discussion_is_enabled = false;
    this.auto_turn = true;
    this.build_on_sentences	= [];
    this.challenge_sentences = [];
    this.enable_grading =	true;
    this.language =	"gb";
    this.new_idea_sentences = [];
    this.point_cap = null;
    this.points_settings = [];
    this.question_sentences = [];
    /* ----------------------------------------- */
    this.selected_criteria_tags = [];
    this.max_score = null;
  }
}

export class Sentence {
  constructor(name, is_active, is_custom) {
    this.sentence = name;
    this.is_active = is_active;
    this.is_custom = is_custom;
  }
}

export class NewIdeaSentences {
  constructor() {
    this.new_idea_sentences = [];
  }

  newIdeaSentence(name, is_active, is_custom){
    const question = new Sentence(name, is_active, is_custom);
    this.new_idea_sentences.push(question);
    return question;
  }

  get allNewIdeaSentences() {
    return this.new_idea_sentences;
  }
}

export class BuildOnSentences {
  constructor() {
    this.build_on_sentences = [];
  }
  newBuildOnSentence(name, is_active, is_custom){
    const question = new Sentence(name, is_active, is_custom);
    this.build_on_sentences.push(question);
    return question;
  }
  get allBuildOnSentences() {
    return this.build_on_sentences;
  }
}
export class ChallengeSentences {
  constructor() {
    this.challenge_sentences = [];
  }
  newChallengeSentence(name, is_active, is_custom){
    const question = new Sentence(name, is_active, is_custom);
    this.challenge_sentences.push(question);
    return question;
  }

  get allChallengeSentences() {
    return this.challenge_sentences;
  }
}
export class QuestionSentences {
  constructor() {
    this.question_sentences = [];
  }

  newQuestionSentence(name, is_active, is_custom) {
    const question = new Sentence(name, is_active, is_custom);
    this.question_sentences.push(question);
    return question;
  }

  get allQuestionSentences() {
    return this.question_sentences;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/Utils/Objects/DefaultVerbalSettings.js